import './auctions-api.factory';
